<template>
    <v-layout class="app-content login-page">
        <v-flex>
            <v-layout class="form-layout" wrap pa-12 align-center>
                <v-card class="pa-4 " style="width: 400px; border-radius: 10px;">
                    <h1 class="mb-6 text--primary">Painel Administrativo</h1>
                    <v-form ref="form" @submit.prevent="logar">
                        <v-text-field
                                placeholder="Login"
                                solo
                                validate-on-blur
                                background-color="lightgray"
                                class="required pagamento-text-field"
                                v-model="login"
                                :rules="[$rules.required]">
                            <v-icon class="mr-1" slot="prepend-inner"
                                    color="darkgray">
                                person
                            </v-icon>
                        </v-text-field>
                        <v-text-field
                                placeholder="Senha"
                                :type="pass_visible ? 'text' : 'password'"
                                solo
                                background-color="lightgray"
                                validate-on-blur
                                class="required pagamento-text-field"
                                v-model="senha"
                                :rules="[$rules.required]"
                                maxlength="100">
                            <v-icon class="mr-1" slot="prepend-inner"
                                    color="darkgray">
                                vpn_key
                            </v-icon>
                            <v-icon slot="append"
                                    @click="pass_visible = !pass_visible"
                                    :color="pass_visible ? 'primary' : 'darkgray'">
                                ol-visibility
                            </v-icon>
                        </v-text-field>
                        <v-flex>
                            <v-btn x-large class="button btn-default" type="submit">Entrar</v-btn>
                        </v-flex>
                    </v-form>
                </v-card>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
  import { notification, sleep } from '@/plugins/helpers'
  import { autenticarPainel } from '@/webservice/autenticar'
  import { loadFlavor } from '@/plugins/flavors'
  import { apagarTextoApos } from '../../plugins/helpers'
  import { AlertTypes } from '@/plugins/alerts_types'

  export default {
    data () {
      return {
        pass_visible: false,
        login: '',
        senha: ''
      }
    },
    created () {
      loadFlavor('rodobens')
    },
    methods: {
      logar () {
        const form = this.$refs.form

        if (form.validate()) {
          autenticarPainel(this.login, this.senha)
            .then(res => {
              // Não é isso que autentica o usuário, isso é só pra economizar uma requisição. Quem valida se o usuário é admin é o backend
              this.$session.set('super_admin', res.data['super_admin'])
              this.$session.set('exibe_contratos_painel', res.data['exibe_contratos_painel'])
              this.$session.set('admin', true)
              this.$router.replace('/painel')
            })
            .catch(err => {
              this.$store.commit('destroy')
              let errorMsg

              // Se tiver Msg_Erro no response, ajusta ela
              if (err.response?.data?.Msg_Erro) {
                err.response.data.Msg_Erro = apagarTextoApos(
                  err.response.data.Msg_Erro,
                  'antes do seu acesso ser bloqueado!'
                )
                errorMsg = err.response.data.Msg_Erro
              } else {
                errorMsg = err.response?.data?.error || err.message || 'Erro desconhecido'
              }

              notification(AlertTypes.ERROR, errorMsg)
            })
        } else {
          form.resetValidation()
          sleep(100).then(() => form.validate())
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .app-content {
      background-image: url(../../assets/img/painel-bg.jpg) !important;
  }
  .background--grey input{
    background-color: grey;
  }
</style>
